import React, { useEffect, useState } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { Col, Row } from "antd";
import ContactDetails from "./ContactDetails";
import ContactForm from "./ContactForm";
import Loader from "../../../biblio/Loader/Loader";
import useIsMobile from "../../../biblio/mobileVersion/useIsMobile";

const ContactUs = () => {
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="تواصل معنا"
      subTitle="إتصل بنا"
      urlImage={banner}
    >
      <Row dir="rtl" justify={"space-between"}>
        <Col xxl={2} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col
          xxl={10}
          xl={15}
          lg={9}
          md={12}
          sm={24}
          xs={24}
          style={{
            padding: isMobile ? "0 0.5rem 1rem 0.5rem" : "0 2rem 2rem 2rem",
          }}
        >
          <ContactDetails />
        </Col>
        <Col
          xxl={6}
          xl={7}
          lg={11}
          md={11}
          sm={24}
          xs={24}
          style={{ padding: "0 2rem" }}
        >
          <ContactForm />
        </Col>
        <Col xxl={2} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </MenuItemLayout>
  );
};

export default ContactUs;
